import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface UrlValidatorError {
  url: true;
}

/**
 * Validate an url
 * @param control
 * @returns
 */
export const UrlValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const REGEX_NAME =
    // eslint-disable-next-line no-useless-escape
    /^(https?):\/\/((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|(\d{1,3}\.){3}\d{1,3}|\[?[a-f\d:]+\]?)(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
  const regexp = new RegExp(REGEX_NAME);
  return !control.value || regexp.test(control.value) ? null : ({ url: true } as UrlValidatorError);
};
